/* TocaStar · selector de packs (precios sincronizados con Shopify) */
(function () {
  var NF = null;
  try { NF = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }); } catch (e) {}
  function fmt(c) { return NF ? NF.format(c / 100) : (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function set(root, sel, txt) { var el = root.querySelector(sel); if (el) el.textContent = txt; }

  function init(box) {
    if (box.__tsp) return;
    box.__tsp = true;
    var cards = Array.prototype.slice.call(box.querySelectorAll('[data-tsp-card]'));
    var tiers = cards.map(function (c) { return { q: +c.dataset.qty, off: +c.dataset.off }; })
      .sort(function (a, b) { return a.q - b.q; });
    var sel = box.dataset.qsel || 'input[name="quantity"]';
    var scope = box.closest('.shopify-section') || document;

    function inputs() { return Array.prototype.slice.call(scope.querySelectorAll(sel)); }
    function getQ() { var i = inputs()[0]; return i ? Math.max(1, parseInt(i.value, 10) || 1) : 1; }
    function offFor(q) { var o = 0; tiers.forEach(function (t) { if (q >= t.q) o = t.off; }); return o; }

    function render() {
      var base = +box.dataset.base;
      cards.forEach(function (c) {
        var q = +c.dataset.qty, off = +c.dataset.off, u = base - off;
        set(c, '[data-tsp-unit]', fmt(u));
        set(c, '[data-tsp-total]', fmt(u * q));
        set(c, '[data-tsp-full]', fmt(base * q));
        set(c, '[data-tsp-save]', fmt(off * q));
      });
      var q = getQ(), off = offFor(q), exact = false;
      cards.forEach(function (c) {
        var on = +c.dataset.qty === q;
        if (on) exact = true;
        c.classList.toggle('is-on', on);
        var r = c.querySelector('input'); if (r) r.checked = on;
      });
      var live = box.querySelector('[data-tsp-live]');
      if (live) {
        if (!exact && q > 1) {
          live.hidden = false;
          set(live, '[data-tsp-ltotal]', fmt((base - off) * q));
          set(live, '[data-tsp-lsave]', off ? '(ahorras ' + fmt(off * q) + ')' : '');
        } else { live.hidden = true; }
      }
      box.dispatchEvent(new CustomEvent('tsp:change', { bubbles: true, detail: { qty: q, base: base, unit: base - off, off: off } }));
    }

    function setQ(q) {
      inputs().forEach(function (i) {
        i.value = q;
        i.dispatchEvent(new Event('input', { bubbles: true }));
        i.dispatchEvent(new Event('change', { bubbles: true }));
      });
      render();
    }

    cards.forEach(function (c) {
      var r = c.querySelector('input');
      if (r) r.addEventListener('change', function () { setQ(+c.dataset.qty); });
    });
    ['input', 'change'].forEach(function (ev) {
      scope.addEventListener(ev, function (e) { if (e.target.matches && e.target.matches(sel)) render(); }, true);
    });
    scope.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-ts-minus],[data-ts-plus],quantity-selector-component button,.quantity-selector button')) setTimeout(render, 40);
    });
    box.tspSetVariant = function (cents, src) {
      if (cents) box.dataset.base = cents;
      if (src) box.querySelectorAll('[data-tsp-img]').forEach(function (im) { im.src = src; });
      render();
    };
    document.addEventListener('variant:update', function (e) {
      var v = e.detail && (e.detail.resource || e.detail.variant);
      if (!v) return;
      var src = null;
      try { src = v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src; } catch (x) {}
      if (src) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      box.tspSetVariant(v.price, src);
    });
    render();
  }

  function boot() { document.querySelectorAll('[data-tsp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
